module.exports = __webpack_public_path__ + "img/messages.f2bfa982.svg";